import { BaseTradeService } from '../../base-trade.service';
import { LandscapeSupportersSaveRequestDto } from '../dto/request/landscape-suporters-save-request.dto';
import { LandscapeSupportersUpdateRequestDto } from '../dto/request/landscape-supporters-update-request.dto';
import { LandscapeSupportersResponseDto } from '../dto/response/landscape-suporters-response.dto';

class LandscapeSupportersService extends BaseTradeService {
  public async fetchCompactSupportersByLandscapeId(
    landscapeId: string
  ): Promise<LandscapeSupportersResponseDto[]> {
    const response = await this.get<LandscapeSupportersResponseDto[]>(
      `/compactsupporters/getbycompactid/${landscapeId}`
    );
    return response.data;
  }
  public async fetchCompactSupportersConvenersByLandscapeId(
    landscapeId: string
  ): Promise<LandscapeSupportersResponseDto> {
    const response = await this.get<LandscapeSupportersResponseDto>(
      `/compactsupporters/getconvenersbycompactid/${landscapeId}`
    );
    return response.data;
  }

  public async fetchCompactSupportersConsortiumsByLandscapeId(
    landscapeId: string
  ): Promise<LandscapeSupportersResponseDto> {
    const response = await this.get<LandscapeSupportersResponseDto>(
      `/compactsupporters/getconsortiumsbycompactid/${landscapeId}`
    );
    return response.data;
  }

  public async fetchCompactSupportersById(
    compactSupporterId: string
  ): Promise<LandscapeSupportersResponseDto> {
    const response = await this.get<LandscapeSupportersResponseDto>(
      `/compactsupporters/${compactSupporterId}`
    );
    return response.data;
  }

  public async fetchCompactSupportersByOrganizationId(
    organizationId: string
  ): Promise<LandscapeSupportersResponseDto[]> {
    const response = await this.get<LandscapeSupportersResponseDto[]>(
      `/compactsupporters/getcompactsupportersbyorganizationid/${organizationId}`
    );
    return response.data;
  }

  public async saveCompactSupporter(
    saveRequest: LandscapeSupportersSaveRequestDto
  ): Promise<LandscapeSupportersResponseDto> {
    const response = await this.post<LandscapeSupportersResponseDto>(
      `/compactsupporters`,
      saveRequest
    );
    return response.data;
  }

  public async updateCompactSupporters(
    updateRequest: LandscapeSupportersUpdateRequestDto
  ): Promise<LandscapeSupportersResponseDto> {
    const response = await this.put<LandscapeSupportersResponseDto>(
      `/compactsupporters`,
      updateRequest
    );
    return response.data;
  }

  public async deleteCompactSupporter(
    compactSupporterId: string
  ): Promise<void> {
    await this.delete<void>(`/compactsupporters/${compactSupporterId}`);
  }
}

const landscapeSupportesService = new LandscapeSupportersService();
export default landscapeSupportesService;
